import { render, staticRenderFns } from "./visit-recover-case-manage.vue?vue&type=template&id=284b83e2&scoped=true"
import script from "./visit-recover-case-manage.vue?vue&type=script&lang=ts"
export * from "./visit-recover-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b83e2",
  null
  
)

export default component.exports